import { Emitter } from "pixi-particles";
import { Container } from "./container";

export class ParticleContainer extends Container {
    public emitterId: number;
    public emitter: Emitter;
}
